import { FeaturePermissionsTemplate } from "../../templates/templates";
import { EditorUser, HoldingUserPermissions } from "../../types";
import { AppDispatch } from "../hooks";
import { GroupCell } from "./cells/dropdown/GroupCell";

interface Props {
    app: keyof HoldingUserPermissions
    templates: { [permission: string]: FeaturePermissionsTemplate<{}> }
    dispatch: AppDispatch
    user: EditorUser
}

export function FeatureGroupPermissions({ user, app, templates, dispatch }: Props) {

    const setPermissions = (values: { read: boolean, write: boolean }) => {

        const updates = Object.entries(templates)
            .map(([key, template]: [key: string, template: FeaturePermissionsTemplate<{}>]) => {

                key = `${app}.${key}`

                const current = user.holdingPermissions[key]

                if (!current.availability.member) {
                    return
                }

                const financialData = template.type === "readWriteFinancial"
                    ? current?.values?.["financialData"]
                    : undefined

                const u = template.type === "access"
                    ? {
                        enabled: Boolean(values.read)
                    }
                    : {
                        ...values,
                        financialData
                    }

                return {
                    key,
                    values: u
                }

            })
            .filter(a => Boolean(a))


        dispatch({
            type: "updatePermissions",
            payload: {
                userId: user.userId,
                updates
            }
        })

    }


    return <GroupCell setPermissions={setPermissions} />

}
